<template><VisitList title="ویزیت‌های تکمیل‌شده" status="2" /></template>
<script>
import VisitList from './VisitList.vue';
export default { components: { VisitList } };
</script>
